import axios from 'axios'
import config from '@/config'
import { Toast } from 'vant'
import Stack from './stack'
import store from '@/store'
import $utils from '@/utils/utils'

const stack = new Stack()
Toast.allowMultiple(true)

const http = axios.create({
	baseURL: config.httpApiUrl,
	timeout: config.httpTimeout
})

http.interceptors.request.use(
	config => {
		config.headers.token = store.getters['account/getToken']

		if (['post', 'put'].includes(config.method)) {
			const requestAbout = new AbortController()
			config.signal = requestAbout.signal
			stack.append(config, { requestAbout })
		}

		return config
	},
	error => {
		return Promise.reject(error)
	}
)

http.interceptors.response.use(
	response => {
		stack.remove(response.config)
		const data = response.data

		// 登录失效处理
		if (config.againLoginCode.includes(data.code)) {
			$utils.loginFailure(() => stack.abortAll().clear())
			throw new Error('noToast')
		}
		return response
	},
	error => {
		return Promise.reject(error)
	}
)

/**
 * options 参数说明
 * @params { boolean } noToast 是否显示toast，default: false
 */
const commonPromise = (method, url, params, options = {}) => {
	return new Promise((resolve, reject) => {
		const toastLoading = Toast.loading({
			message: '加载中...',
			forbidClick: true,
			loadingType: 'spinner',
			duration: 0
		})
		http[method](url, ['get'].includes(method) ? { params } : params)
			.then(res => {
				toastLoading.clear()
				if (res.data.code && !options.noToast) {
					if (!config.noToastCode.includes(res.data.code)) {
						Toast(res.data.msg)
					}
				}
				resolve(res.data)
			})
			.catch(err => {
				toastLoading.clear()
				if (err.code !== 'ERR_CANCELED' && err.message !== 'noToast') {
					Toast('网络异常，请检查网络后重试')
				}
				reject(err)
			})
	})
}

const promiseAll = (list, cb) => {
	Promise.all(list).then(res => cb(res))
}

export default {
	get: (url, params, options) => commonPromise('get', url, params, options),
	post: (url, data, options) => commonPromise('post', url, data, options),
	put: (url, data, options) => commonPromise('put', url, data, options),
	delete: (url, params, options) => commonPromise('delete', url, params, options),
	/**
	 * @param { Object } list
	 * @param { Function } cb
	 */
	all: (list, cb) => {
		const _list = Object.values(list)
		const _keys = Object.keys(list)

		const result = {}
		for (let i = 0; i < Math.ceil(_list.length / config.httpMergeNum); i++) {
			promiseAll(_list.slice(i * config.httpMergeNum, config.httpMergeNum), res => {
				res.forEach((item, index) => {
					result[_keys[index + i * config.httpMergeNum]] = item
				})

				if (!(Object.keys(result).length ^ _keys.length)) {
					cb && cb(result)
				}
			})
		}
	}
}
